import { api } from 'api'

export const assignUserIdentity = async ({ regNo }: { regNo: string }): Promise<string> => {
  const response = await api.vehicles.assignUserIdentity(regNo)

  return response.data
}
